<i18n>
{
	"en": {
		"parallelSuborder": "Create Parallel Suborder"
	},
	"no": {
		"parallelSuborder": "Lag parallell strekning"
	}
}
</i18n>
<template>

	<div class="sub-order-list">

		<template v-for="(subOrder, index) in subOrders">
			<SubOrderListCard


				:key="index"
				:style="{
					paddingTop:
						index === 0
							? '8px'
							: '12px',

					paddingRight: '8px',
					paddingBottom: '10px',
					paddingLeft: '6px',

					borderRadius: '10px',

					marginRight: '5px',
				}"

				:despatchParty="subOrder.despatchParty"
				:deliveryParty="subOrder.deliveryParty"
				:subOrderId="subOrder.id"
				:edi="subOrder.edi"
				:etd="subOrder.etd"
				:atd="subOrder.atd"
				:isUsingAtd="Boolean(subOrder.atd && subOrder.atd.date)"

				:eta="subOrder.eta"
				:ata="subOrder.ata"
				:isUsingAta="Boolean(subOrder.ata && subOrder.ata.date)"

				:isCurrentSuborder="selectedSubOrder && selectedSubOrder.id === subOrder.id"

				@click="$emit('selected',index)"
			>
				<template v-slot:contextMenu>
					<t-menu>
						<t-menu-group>
							<t-menu-item
								icon="edit"
								@click="$emit('createParallelSuborder', subOrder.id)"
							>
								<strong>{{ $t('parallelSuborder') }}</strong>
							</t-menu-item>
						</t-menu-group>
					</t-menu>
				</template>
			</SubOrderListCard>
		</template>

	</div>
</template>

<script>
import {
	mapState
} from '../store/newOrder.store.js';
import SubOrderListCard from '@/modules/newOrder/subOrders/SubOrderListCard';

export default {
	name: 'SubOrderList',
	components: { SubOrderListCard },
	computed: {
		...mapState([
			'subOrders',
			'selectedSubOrder',
		])
	},
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';

.sub-order-list {
	margin-top: 12px;
}

hr {
	height: 1px;
	background: get-color($border, 'default');
	width: 100%;
	border: 0;
	margin: 0;
}

</style>